
import React from 'react';

import Card from './Card';
import { drawDetailsProps } from './apis/getDrawDetail';
import VeticalBingoCard from './veticalBingoCard';
import useWindowSize from './utils/useWindowSize';
interface bingoCardsProps{
  calledNumbers:number[]
    drawDetails: drawDetailsProps | undefined
    isMobile?:boolean
    maxNumbers:number
}

const BingoCards: React.FC<bingoCardsProps> = ({calledNumbers ,maxNumbers,drawDetails ,isMobile }) => {
  
 return (
    <div className="flex justify-center w-full p-1">
      
      <div className="max-w-[1100px]   h-full  items-center justify-center ">
       {/* {
        isMobile ? 
        <VeticalBingoCard   maxNumberRange={maxNumbers} 
        calledNumbers={calledNumbers}
        isMobile={isMobile} /> :  */}
         <Card
        maxNumberRange={maxNumbers} 
        calledNumbers={calledNumbers}
        isMobile={isMobile}
      />
       {/* }   */}
      </div>
      
      
    </div>
  );
};

export default BingoCards;